import CommonError from '../Common/CommonError'

const Error500Container = () => {
  return (
    <CommonError color="primary" src="5" />
  )
}

export default Error500Container